import React from 'react';
import {Button, Icon, Table, Header, Popup, Loader, Segment, Grid} from 'semantic-ui-react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import PaginationFront from "../../util/PaginationFront";
import {ExportReactCSV} from "../../util/ExportCSV";
import SearchTableData from "../../util/SearchTableData";
import ReactExport from 'react-data-export';
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema uposlenika.</p>;

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

export default class EmployeesTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: this.props.loader,
            employeeName: '',
            showEmployees: false,
            loading: false,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            results: [],
        };

        this.getDataToRender = this.getDataToRender.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.employeeName !== nextProps.employeeName) {
            this.setState({
                results: []
            });
        }
    }


    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.props.data;
    }

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })


    render() {
        const headersForExport = [
            { label: 'Prezime', key: 'lastName' },
            { label: 'Ime', key: 'firstName' }
        ];

        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 200 } },
                    { title: 'Ime', width: { wpx: 200 } },
                ],
                data: this.props.excelData,
            }
        ];

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        const activeRole = localStorage.getItem('activeRole');
        return (
            <div>


                {this.state.loading && <div style={{ paddingTop: '100px', paddingBottom: '100px' }} ><Loader active inline="centered" /></div>}
                {!this.props.loader ? <div> {currentPosts.length ?

                    <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={9} >
                                    <Grid columns={2} stackable>

                                        <Grid.Column width={14}>
                                            <SearchTableData profMozilla data={this.props.data} getResults={this.getResults} filterItem={['firstName', 'lastName']} />
                                        </Grid.Column>
                                        <Grid.Column width={2} textAlign={'center'}>
                                            <ExcelFile filename="Spisak nastavnog osoblja" element={<Popup
                                                trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                    <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                    <Button.Content visible>
                                                        Excel
                                                    </Button.Content>
                                                </Button>}
                                                content="Preuzmi spisak u Excel-u"
                                                hideOnScroll
                                                position="top center"
                                            />}>
                                                <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name={this.props.employeeName === "assistant" ? "Asistenti" :this.props.employeeName === "demonstrator" ? "Demonstratori" : this.props.employeeName === "laborant" ? "Laboranti" : this.props.employeeName ==="associate" ? "Saradnici" :"Profesori"} />
                                            </ExcelFile>
                                        </Grid.Column>
                                    </Grid>
                                </Table.HeaderCell>
                                {/*<Table.HeaderCell colSpan={9} >*/}
                                {/*        <span>*/}
                                {/*            <ExportReactCSV color="green" csvData={this.props.data} headers={headersForExport} floated="right" fileName="Spisak nastavnog osoblja" />*/}
                                {/*            <SearchTableData data={this.props.data} getResults={this.getResults} filterItem={['firstName', 'lastName']} />*/}
                                {/*        </span>*/}
                                {/*</Table.HeaderCell>*/}
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell width="1">
                                    R. br.
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>
                                    Prezime
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>
                                    Ime
                                </Table.HeaderCell>
                                {activeRole.substr(0, 8) === 'Student:' ?
                                    <Table.HeaderCell colSpan={2}>
                                        Email
                                    </Table.HeaderCell>

                                    : <Table.HeaderCell width="3" colSpan={2}>
                                    </Table.HeaderCell>}

                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {currentPosts.map((el, index) =>
                            (<Table.Row key={index} >
                                    <Table.Cell verticalAlign="middle" width={1}>
                                        {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                    </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={3}>
                                    {el.lastName}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={3}>
                                    {el.firstName}
                                </Table.Cell>
                                {activeRole.substr(0, 8) === 'Student:' ?
                                    <Table.Cell colSpan={2}>
                                        {/* eslint-disable-next-line react/jsx-no-target-blank */}
                                        {el.emails.length === 0 ? '' : <a target="_blank" href={'mailto:' + el.emails[0].value}> <Icon size="small" name="mail" />  {el.emails[0].value}  </a>}
                                    </Table.Cell>
                                    : <Table.Cell textAlign="center" width="3" colSpan={2}>
                                        {this.props.userButton ?
                                            <Button
                                                color="blue"
                                                basic="true"
                                            >
                                                Kreiranje/reset šifre
                                            </Button>
                                            :
                                            (localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu') &&
                                            <Link to={{ pathname: '/nastavno-osoblje/lični-podaci', state: { id: el.id, studentService: true } }}>
                                                <Popup
                                                    content="Lični podaci"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic="true"
                                                            circular
                                                            size="small"
                                                            color="blue"
                                                            icon="user"
                                                            onClick={() => {
                                                                localStorage.setItem('employeeId', el.id);
                                                                localStorage.setItem('organizationalUnitEmployeeId', el.organizationalUnitEmployeeId);}
                                                            }
                                                            disabled={localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                                                        />}
                                                /></Link>}
                                        {(this.props.professor && !this.props.userButton) && <Link to={{ pathname: '/nastavno-osoblje/predmeti', state: { id: el.id, studentService: true } }}>
                                            <Popup
                                                content="Predmeti"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        color="blue"
                                                        basic="true"
                                                        circular
                                                        size="small"
                                                        icon="list"
                                                        onClick={() => localStorage.setItem('employeeId', el.id)}
                                                    />}
                                            /></Link>}
                                        {(this.props.professor && !this.props.userButton) && <Link to={{ pathname: '/nastavno-osoblje/mentorstva', state: { id: el.id, studentService: true, organizationalUnitId: localStorage.getItem('orgUnit') } }}>
                                            <Popup
                                                content="Mentorstva"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        color="teal"
                                                        basic="true"
                                                        circular
                                                        size="small"
                                                        icon="student"
                                                        onClick={() => {
                                                            localStorage.setItem('id', el.id);
                                                            localStorage.setItem('employeeId', el.id);
                                                        }}
                                                    />}
                                            /></Link>}
                                    </Table.Cell>}
                            </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                    : !this.state.loading && <NoDataMessage />
                }
                </div> : <div style={{ paddingTop: '100px', paddingBottom: '100px' }} ><Loader active inline="centered" /></div>}

                {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Employees/EmployeesTable.js